import { P, FF, inputBase } from "../../styles/tokens";

const TIPO_ICON = { efectivo: "💵", "débito": "💳", "crédito": "💳", vales: "🎫", ahorro: "🐿️" };

/**
 * Selector compacto de cuenta/método de pago.
 * Muestra un pill/select con icono + nombre corto.
 */
export default function AccountSelect({ value, onChange, cuentas = [], required = false }) {
  if (!cuentas.length) return null;

  const selected = cuentas.find((c) => c.id === value);
  const missing = required && !selected;

  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
      title={selected ? `${selected.nombre} (${selected.tipo})` : "Seleccionar cuenta"}
      style={{
        ...inputBase,
        width: "auto",
        minWidth: 44,
        maxWidth: 120,
        fontSize: 11,
        fontWeight: 700,
        padding: "5px 6px",
        flexShrink: 0,
        color: selected ? P.ingresos.base : missing ? "#DC2626" : P.textXs,
        background: selected ? P.ingresos.pastel : missing ? "#FEF2F2" : P.bg,
        borderColor: selected ? P.ingresos.tint : missing ? "#FECACA" : P.border,
        appearance: "auto",
        cursor: "pointer",
      }}
    >
      <option value="">{missing ? "⚠ Cuenta" : "💳"}</option>
      {cuentas.map((c) => (
        <option key={c.id} value={c.id}>
          {TIPO_ICON[c.tipo] || "💳"} {c.nombre}
        </option>
      ))}
    </select>
  );
}
